// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"48d19778","96":"9d872a6e","362":"89f5b90c","637":"85643228","841":"5b546acb"}[chunkId] + ".css";
};